import { get } from "node-emoji";

export const Emojis = {
  HEART: get("heart"),
  COFFEE: get("coffee"),
  BEER: get("beer"),
  BROKEN_HEART: get("broken_heart"),
  CRYING: get("crying_cat_face"),
  HEART_EYES: get("heart_eyes_cat"),
  JOY: get("joy_cat"),
  KISSING: get("kissing_cat"),
  SCREAM: get("scream_cat"),
  ROCKET: get("rocket"),
  SMIRK: get("smirk_cat"),
  RAISED_HANDS: get("raised_hands"),
  POINT_RIGHT: get("point_right"),
  SPARKLES: get("sparkles"),
  BOOM: get("boom"),
  PRAY: get("pray"),
  WINE: get("wine_glass"),
};
